import { SVGProps } from "react";


const ArrowCancelSVG = (props: SVGProps<SVGElement>) => {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.33333 0.75L0.75 5.33333L5.33333 9.91667M0.75 5.33333H10.375C11.0371 5.33333 11.6927 5.46374 12.3044 5.71711C12.916 5.97048 13.4718 6.34184 13.94 6.81C14.4082 7.27817 14.7795 7.83395 15.0329 8.44564C15.2863 9.05732 15.4167 9.71292 15.4167 10.375C15.4167 11.0371 15.2863 11.6927 15.0329 12.3044C14.7795 12.916 14.4082 13.4718 13.94 13.94C13.4718 14.4082 12.916 14.7795 12.3044 15.0329C11.6927 15.2863 11.0371 15.4167 10.375 15.4167H7.16667" 
            stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default ArrowCancelSVG;

